import env from 'configuration'
import { useAgency } from 'context/agency'
import { AuthInit } from 'context/auth'
import { LocationInit } from 'context/location'
import useScript from 'hooks/script'
import { useEffect } from 'react'
import { useRoutes } from 'react-router-dom'
import Routes from 'routing/routes'
import { setGHLSessionKey } from 'utils/auth-helper'

// BUG-17: React logged "change in the order of Hooks called by App" on every session.
// Routes() is a plain function that calls useAuth() and useLocationInfo(), and it was
// invoked as useRoutes(Routes()) at App's top level — so its hooks folded into App's
// render, and it read contexts supplied by <AuthInit> and <LocationInit>, which are App's
// own CHILDREN. It therefore ran before its providers existed and its hook sequence
// shifted once they populated. Resolving the routes inside the providers scopes those
// hooks to their own component and keeps App's hook list stable.
function RoutedApp() {
  return useRoutes(Routes())
}

function App() {
  const { agency } = useAgency()
  const scriptLoaded = useScript(
    `https://maps.googleapis.com/maps/api/js?key=${env.G_MAP_API_KEY}&loading=async&libraries=places`
  )

  const bg_color = agency?.location_config?.page_bg_color

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search)
    const sessionkey = queryParams.get('sessionkey')

    if (sessionkey) setGHLSessionKey(sessionkey)
  }, [])

  return (
    <div
      style={{
        backgroundColor: bg_color,
      }}
      className='h-screen overflow-y-auto relative'
    >
      <AuthInit>
        <LocationInit>
          <RoutedApp />
        </LocationInit>
      </AuthInit>
    </div>
  )
}

export default App
